import classNames from 'classnames/bind';

import styles from './S02.module.scss';

const cx = classNames.bind(styles);

const S02 = () => {
  return (
    <div className={cx('container')}>
      <div className={cx('limiter')}>
        <div className={cx('videoWrapper')}>
          <iframe
            src="https://www.youtube.com/embed/BqJYchZAgV4?si=UJNgp_MfPnVfoE6l"
            title="YouTube video player"
            allowFullScreen
            className={cx('video')}></iframe>
        </div>
      </div>
    </div>
  );
};

export default S02;
